import { LocalStorage } from '@lockton-apps/shared/data-access/storage';
import { Proposal } from '@lockton-apps/shared/interfaces';

export class ProposalBackupService {
  static set(proposal: Proposal): void {
    LocalStorage.set(this.buildKey(proposal.id), proposal);
  }

  static get(proposalId: string | undefined): Proposal | null {
    if (!proposalId) {
      return null;
    }

    return LocalStorage.get<Proposal>(this.buildKey(proposalId));
  }

  static has(proposalId: string | undefined): boolean {
    if (!proposalId) {
      return false;
    }

    return LocalStorage.has(this.buildKey(proposalId));
  }

  static delete(proposalId: string): void {
    LocalStorage.delete(this.buildKey(proposalId));
  }

  private static buildKey(keyPartial: string): string {
    return `backup.${keyPartial}`;
  }
}
